import { UserContext } from 'context/User/UserContext';
import { useContext } from 'react';
import TerminateEmployeeAccessStepper from './TerminateEmployeeStepper/TerminateEmployeeStepper';
import { useFormik } from 'formik';
const ReviewEmployeeAccess = ({
	initialValuesFromParams,
	targetUser,
	messages,
}) => {
	/**
	 * @type {import('context/User/UserContext').ContextUser}
	 */
	const contextUser = useContext(UserContext);
	const user =
		contextUser.userInfo.impersonationProfile ??
		contextUser.userInfo.userProfile;

	const validate = values => {
		const errors = {};

		if (values.staffMembersForReview?.length === 0) {
			errors.staffMembersForReview =
				'You must select at least one staff member to terminate';
		}
		return errors;
	};
	const formik = useFormik({
		initialValues: {
			staffMembersForReview:
				initialValuesFromParams.length > 0
					? initialValuesFromParams.map(o => ({
							...o,
							isSelected: true,
					  }))
					: [],
			validatedStaffMembers: [],
			currentUser: contextUser.userInfo.userProfile,
		},
		validate,
	});

	return (
		<TerminateEmployeeAccessStepper
			formik={formik}
			currentUser={user}
			loggedInUser={contextUser.userInfo.userProfile}
			targetUser={targetUser}
			messages={messages}
		/>
	);
};

export default ReviewEmployeeAccess;
